import * as yup from 'yup';

export default yup.object().shape({
  name: yup
    .string()
    .trim()
    .min(3)
    .required('The name must be at least 3 characters'),
});
